import { MIME_TYPES_MAP } from "./Constants";

export const capitalize = (word: string) => {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

export const removeAccents = (word: string) => {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
};

export function isSuccessfulResponse(
  response: any,
  expectedStatuses: number[] = [200, 201]
): boolean {
  return (
    response &&
    typeof response.status === 'number' &&
    expectedStatuses.includes(response.status)
  );
}

export function hasError(response: any): {
  isClientError: boolean;
  isTechError: boolean;
  isAnyError: boolean;
} {
  if (!response || typeof response.status !== 'number') {
    return { isClientError: false, isTechError: false, isAnyError: false };
  }

  const isClientError = response.status >= 400 && response.status < 500;
  const isTechError = response.status >= 500;
  const isAnyError = isClientError || isTechError;

  return { isClientError, isTechError, isAnyError };
}

export function hasData<T>(response: any): response is { data: T } {
  return response && 'data' in response;
}

export function hasContent<T>(
  response: any
): response is { data: { content: T } } {
  return response && 'data' in response && response.data?.content;
}

export const isEmptyValue = (value: any): boolean => {
  return value === '' || value == null || Number.isNaN(value);
};

export const getRolesFromToken = (): string[] => {
  const token = localStorage.getItem('roles');
  return token ? token.split(',') : [];
};

export const removeFileExtension = (filename: string) => {
  return filename.substring(0, filename.lastIndexOf('.')) || filename;
};

export const toNumber = (val: number | string) => {
  if (typeof val === 'number') return val;
  if (typeof val === 'string') {
    const num = parseFloat(val.replace(/\./g, '').replace(',', '.'));
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

export const getMimeType = (filename: string): string => {
  const extension = filename.split('.').pop()?.toLowerCase() ?? '';
  return MIME_TYPES_MAP[extension] || 'application/octet-stream';
};

export const getEnabledRiskCodes = (codes: string[]): string[] => {
  const config = JSON.parse(localStorage.getItem('config') ?? '{}');
  const isCasfogEnabled = config?.isCasfogEnabled ?? true;
  
  if (isCasfogEnabled) {
    return codes;
  }
  
  return codes.filter(code => code !== 'CASFOG');
};
